import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-store-icon',
  templateUrl: './store-icon.component.html',
})

export class StoreIconComponent {
  @Input() color: string = '';
}
